import React, { useEffect, useState } from 'react';
import { listBrokerPartners, listInterestSubmissions } from '../utils/api';
import { useToast } from './Toast';

const Partners = ({ language = 'ar' }) => {
  const isRTL = language === 'ar';
  const toast = useToast();
  const [partners, setPartners] = useState([]);
  const [brokerSubs, setBrokerSubs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const [p, s] = await Promise.all([
          listBrokerPartners(),
          listInterestSubmissions({ kind: 'broker', limit: 100 }),
        ]);
        if (!cancelled) {
          setPartners(p.data?.partners || []);
          setBrokerSubs(s.data?.submissions || []);
        }
      } catch (e) {
        toast?.error?.(e.response?.data?.error || e.message);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div style={{ direction: isRTL ? 'rtl' : 'ltr', padding: '8px 0' }}>
      <h2 style={{ margin: '0 0 6px', fontSize: '1.25rem' }}>
        {language === 'ar' ? 'شركاء الوسطاء' : 'Broker partners'}
      </h2>
      <p style={{ margin: '0 0 18px', color: '#64748b', fontSize: '0.9rem' }}>
        {language === 'ar'
          ? 'تسجيلات نموذج الوسطاء من الموقع — منفصلة عن عملاء الشراء/الإيجار.'
          : 'Website broker signups — kept separate from end-buyer clients.'}
      </p>

      {loading && <p style={{ color: '#94a3b8' }}>…</p>}

      <div
        style={{
          background: '#fff',
          border: '1px solid #e2e8f0',
          borderRadius: 14,
          overflow: 'hidden',
          marginBottom: 20,
        }}
      >
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.85rem' }}>
          <thead>
            <tr style={{ background: '#fff7ed', color: '#9a3412', textAlign: isRTL ? 'right' : 'left' }}>
              <th style={{ padding: '10px 12px' }}>{language === 'ar' ? 'الاسم / المكتب' : 'Name / office'}</th>
              <th style={{ padding: '10px 12px' }}>{language === 'ar' ? 'الجوال' : 'Phone'}</th>
              <th style={{ padding: '10px 12px' }}>{language === 'ar' ? 'البريد الإلكتروني' : 'Email'}</th>
              <th style={{ padding: '10px 12px' }}>{language === 'ar' ? 'المصدر' : 'Source'}</th>
              <th style={{ padding: '10px 12px' }}>{language === 'ar' ? 'تاريخ' : 'Updated'}</th>
            </tr>
          </thead>
          <tbody>
            {partners.map((p) => (
              <tr key={p.id} style={{ borderTop: '1px solid #f1f5f9' }}>
                <td style={{ padding: '10px 12px', fontWeight: 600 }}>{p.name}</td>
                <td style={{ padding: '10px 12px' }}>{p.phone || '—'}</td>
                <td style={{ padding: '10px 12px' }}>{p.email || '—'}</td>
                <td style={{ padding: '10px 12px' }}>{p.source || p.customer_type}</td>
                <td style={{ padding: '10px 12px', color: '#64748b' }}>
                  {p.updated_at || p.created_at
                    ? new Date(p.updated_at || p.created_at).toLocaleString()
                    : '—'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {!loading && !partners.length && (
          <p style={{ padding: 16, color: '#94a3b8', fontSize: '0.85rem' }}>
            {language === 'ar'
              ? 'لا شركاء بعد. اربط نموذج الوسطاء على الموقع بـ API الاستقبال.'
              : 'No partners yet. Wire their broker form to the intake API.'}
          </p>
        )}
      </div>

      {brokerSubs.length > 0 && (
        <div>
          <h3 style={{ fontSize: '0.95rem', color: '#475569' }}>
            {language === 'ar' ? 'سجل التسجيلات' : 'Signup log'}
          </h3>
          <ul style={{ fontSize: '0.8rem', color: '#64748b' }}>
            {brokerSubs.slice(0, 20).map((s) => (
              <li key={s.id}>
                {s.created_at ? new Date(s.created_at).toLocaleString() : ''} — {s.name} — {s.phone}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default Partners;
